import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import api from "../../../services/api"; // Make sure this is the correct path to your API service

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Monthly Signups",
    },
  },
};

function Chart() {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "User Count",
        data: [],
        borderColor: "rgba(75,192,192,1)",
        borderWidth: 2,
        fill: false,
      },
    ],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get("/admin/dashboard/get-users-data");
        const data = response.data.data;

        const months = data.map((item) =>
          new Date(item.month).toLocaleString("default", { month: "long" })
        );
        const userCounts = data.map((item) => item.userCount);

        setChartData({
          labels: months,
          datasets: [
            {
              label: "User Count",
              data: userCounts,
              borderColor: "rgba(75,192,192,1)",
              borderWidth: 2,
              fill: false,
            },
            {
              label: " Count",
              data: userCounts,
              borderColor: "rgba(75,192,192,1)",
              borderWidth: 2,
              fill: false,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching chart data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <p>Loading data...</p>;
  }

  return (
    <div style={{ width: "100%" }}>
      {chartData.labels.length > 0 ? (
        <Line options={options} data={chartData} />
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
}

export default Chart;
